import { Navigate } from "react-router-dom";
import { HeadBarLayout, SimpleLayout } from "../layout";
import { Home, About, Forecast, Alerts, Login } from "../pages";

export default function RouteList() {
    return [
        {
            path: "/",
            layout: SimpleLayout,
            component: () => <Navigate to="/home" replace />
        },
        {
            path: "/home",
            layout: HeadBarLayout,
            component: () => <Home />
        },
        {
            path: "/about",
            layout: HeadBarLayout,
            component: () => <About />
        },
        {
            path: "/alerts",
            layout: HeadBarLayout,
            component: () => <Alerts />
        },
        {
            path: "/forecast",
            layout: HeadBarLayout,
            component: () => <Forecast />
        },
        {
            path: "/login",
            layout: HeadBarLayout,
            component: () => <Login />
        },
    ]
}